// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3kacg","subTitle":"styles_subTitle__2X1xS","leftBack":"styles_leftBack__12-Jf"};